import Highcharts from "highcharts";
import {
  plotOptionsBarBorderColor,
  plotOptionsBarShowInLegend,
  barChartBorderRadius,
} from "./globals";

function chartHeight(clientCount: number): number {
  let barHeight = 20;
  if (clientCount >= 100) {
    barHeight = 18;
  } else if (clientCount >= 20) {
    barHeight = 16;
  } else if (clientCount >= 5) {
    barHeight = 18;
  }
  const chartMargin = 165;
  return clientCount * barHeight + chartMargin;
}

document.addEventListener("turbo:load", () => {
  const charts: NodeListOf<HTMLElement> = document.querySelectorAll(
    "[data-chart='cmmc_levels_by_entity']",
  );

  if (charts) {
    Array.from(charts).forEach((chart) => {
      const clientNames: string[] = JSON.parse(chart.dataset.clientNames!);
      const assessmentTypeData = JSON.parse(chart.dataset.assessmentTypeData!);
      const cmmcLevelData = JSON.parse(chart.dataset.cmmcLevelData!);

      Highcharts.chart({
        chart: {
          renderTo: chart,
          type: "bar",
          height: chartHeight(assessmentTypeData.length),
        },
        title: {
          text: "",
        },
        xAxis: {
          categories: clientNames,
          tickWidth: 0,
          labels: {
            style: {
              fontSize: "14px",
            },
          },
          title: {
            text: null,
          },
        },
        yAxis: {
          labels: {
            style: {
              fontSize: "14px",
            },
          },
          min: 0,
          max: 5,
          opposite: true,
          tickPositions: [0, 1, 2, 3, 4, 5],
          title: {
            text: "",
          },
        },
        tooltip: {
          useHTML: true,
          followPointer: true,
          formatter: function () {
            const context = this as unknown as {
              point: Highcharts.Point;
              series: Highcharts.Series;
            };
            const index = context.point.index;
            const series = context.series.chart.series;
            const assessmentLevel = series[0].data[index].options.y;
            const levelAchieved = Math.round(series[1].data[index].options.y!);
            const color = series[1].data[index].color;
            const row1 =
              '<div style="font-size: 0.9em; font-weight: bold">CMMC Level ' +
              assessmentLevel +
              " Assessment</div><br/>";
            const row2 =
              '<span style="color:' +
              color +
              '">●</span> CMMC Level Achieved:<b> ' +
              levelAchieved +
              "</b><br/>";
            return row1 + row2;
          },
        },
        plotOptions: {
          bar: {
            grouping: false,
            borderColor: plotOptionsBarBorderColor,
            borderWidth: 0,
            borderRadius: barChartBorderRadius,
            showInLegend: plotOptionsBarShowInLegend,
            dataLabels: {
              enabled: false,
            },
          },
        },
        legend: {
          layout: "vertical",
          align: "right",
          verticalAlign: "top",
          x: -40,
          y: 80,
          floating: true,
          borderWidth: 1,
          backgroundColor: "#FFFFFF",
          shadow: true,
        },
        series: [
          {
            name: "Assessment Type CMMC Level",
            data: assessmentTypeData,
          },
          {
            name: "CMMC Level Achieved",
            data: cmmcLevelData,
          },
        ],
      });
    });
  }
});
